import _ from 'lodash';
import { combineReducers } from 'redux';
import {
    EVENT_PUBLISH_START,
    EVENT_PUBLISH_COMPLETE,
    EVENT_UNPUBLISH_START,
    EVENT_UNPUBLISH_COMPLETE,
    EVENT_CANCEL_START,
    EVENT_CANCEL_COMPLETE,
    EVENT_DELETE_START,
    EVENT_DELETE_COMPLETE,
    CLEAR_EVENT_STATUS_ERROR,
    CANCEL_SCHEDULED_PUBLISH_COMPLETE,
    SCHEDULED_PUBLISH_COMPLETE,
    SAVE_SALES_STATUS_START,
    SAVE_SALES_STATUS_COMPLETE,
} from '../actions';

const LOADING_ENDED_ACTION_TYPES = [
    EVENT_PUBLISH_COMPLETE,
    EVENT_UNPUBLISH_COMPLETE,
    EVENT_CANCEL_COMPLETE,
    EVENT_DELETE_COMPLETE,
    CANCEL_SCHEDULED_PUBLISH_COMPLETE,
    SCHEDULED_PUBLISH_COMPLETE,
    SAVE_SALES_STATUS_COMPLETE,
];

const makeStatusLoadingReducer = (loadStartAction, loadEndAction) => (
    state = false,
    action,
) => {
    const { type } = action;

    if (type === loadStartAction) {
        return true;
    }

    if (type === loadEndAction) {
        return false;
    }

    return state;
};

const statusErrorReducer = (state = null, action) => {
    const { type } = action;

    if (type === CLEAR_EVENT_STATUS_ERROR) {
        return null;
    }

    if (_.includes(LOADING_ENDED_ACTION_TYPES, type) && action.error) {
        const {
            payload: { error, detail: errorDetail },
        } = action;

        return {
            error,
            errorDetail,
        };
    }

    return state;
};

export default combineReducers({
    statusError: statusErrorReducer,
    publishLoading: makeStatusLoadingReducer(
        EVENT_PUBLISH_START,
        EVENT_PUBLISH_COMPLETE,
    ),
    unpublishLoading: makeStatusLoadingReducer(
        EVENT_UNPUBLISH_START,
        EVENT_UNPUBLISH_COMPLETE,
    ),
    cancelLoading: makeStatusLoadingReducer(
        EVENT_CANCEL_START,
        EVENT_CANCEL_COMPLETE,
    ),
    deleteLoading: makeStatusLoadingReducer(
        EVENT_DELETE_START,
        EVENT_DELETE_COMPLETE,
    ),
    saveSalesStatusLoading: makeStatusLoadingReducer(
        SAVE_SALES_STATUS_START,
        SAVE_SALES_STATUS_COMPLETE,
    ),
});
